/*
 * @Author: gaobin
 * @Date: 2025-03-13 17:52:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-14 09:52:05
 * @Description: 商品
 */
const productMap = {
  // 获取商品详情
  getProductDetailsExt: '/usb/uwb-app/api/v1/product/detail',
  // 获取详情描述
  getProdDetailsDescExt: '/usb/uwb-app/api/v1/product/getDescription',
  // 添加购物车
  addCartExt: '/usb/uwb-app/api/v1/cart/addCart',
  // 添加到收藏
  addCollectExt: '/usb/uwb-app/api/v1/collect/add',
  // 取消收藏
  cancelCollectExt: '/usb/uwb-app/api/v1/collect/delete',
  // 获取短链连接
  getShortLinks: '/usb/uwb-app/api/v1/productShare/getShareLink',
};

export default productMap;
